export default __webpack_public_path__ + "static/media/event-action-actuator.55dee475.svg";